import GlassesPrescription from "@/views/glasses_prescriptions/glasses_prescription.vue";
import GlassesPrescriptions from "@/views/glasses_prescriptions/index.vue";

export default [
  {
    path: "receitas-oculos",
    name: "Receitas de óculos",
    component: GlassesPrescriptions,
  },
  {
    path: "receitas-oculos/:glassesPrescriptionId",
    name: "Editar Receita de óculos",
    props: true,
    component: GlassesPrescription,
  },
];
